import { render, staticRenderFns } from "./oilfieldAI.vue?vue&type=template&id=0c6567ac&scoped=true"
import script from "./oilfieldAI.vue?vue&type=script&lang=js"
export * from "./oilfieldAI.vue?vue&type=script&lang=js"
import style0 from "./oilfieldAI.vue?vue&type=style&index=0&id=0c6567ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6567ac",
  null
  
)

export default component.exports